/* global SideDrawer */

class CartDrawer extends SideDrawer {
	connectedCallback() {
		this.cartStatus = this.querySelector('[data-cart-status]');
		this.bindEvents();
	}

	bindEvents() {
		this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
		this.closeDrawerViaEventHandler = this.close.bind(this, null);
		document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
		document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
		document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
		this.addEventListener('on:cart-drawer:before-open', () => {
			theme.manuallyLoadImages(this);
			this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
		});
		this.addEventListener('on:cart:after-merge', () => {
			theme.manuallyLoadImages(this);
			this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
		});
	}

	disconnectedCallback() {
		document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
		document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
		document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
	}

	/**
	 * Handle when the drawer is opened via an event
	 * @param {object} evt - Event object.
	 */
	handleDrawerOpenViaEvent(evt) {
		this.open(evt.detail ? evt.detail.opener : null);
	}

	/**
	 * Trigger refresh of contents
	 */
	cartRefreshHandler() {
		this.querySelector('cart-form').refresh();
	}

	/**
	 * Update section's cart-form element with new contents
	 * @param {string} html - Whole-section HTML.
	 */
	updateFromCartChange(html) {
		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = html;

		// Get the current and new cart items to compare
		const currentItems = Array.from(this.querySelectorAll('.cart-item')).map((item) => ({
			title: item.querySelector('.cart-item__title')?.textContent
		}));

		const newItems = Array.from(tempDiv.querySelectorAll('.cart-item')).map((item) => ({
			title: item.querySelector('.cart-item__title')?.textContent
		}));

		// Update the cart contents
		this.querySelector('cart-form').refreshFromHtml(html);

		// Determine what changed and announce it
		this.announceCartChanges(currentItems, newItems);

		const title = this.querySelector('.drawer__close-btn');
		if (title) {
			title.setAttribute('tabindex', '0');
			title.focus();
		}
	}

	/**
	 * Announce cart changes to screen readers
	 * @param {Array} oldItems - Previous cart items
	 * @param {Array} newItems - New cart items
	 */
	announceCartChanges(oldItems, newItems) {
		const changes = [];

		// Check for new or updated items
		newItems.forEach((newItem) => {
			const oldItem = oldItems.find((item) => item.title === newItem.title);
			if (!oldItem) {
				changes.push(`Added ${newItem.title}`);
			}
		});

		// Check for removed items
		oldItems.forEach((oldItem) => {
			const stillExists = newItems.some((item) => item.title === oldItem.title);
			if (!stillExists) {
				changes.push(`Removed ${oldItem.title} from cart`);
			} else {
				changes.push(`Updated ${oldItem.title} in cart`);
			}
		});

		if (changes.length > 0) {
			this.cartStatus.textContent = changes.join('. ');
		}
	}
}

window.customElements.define('cart-drawer', CartDrawer);
